import React from 'react'
import Image from 'next/image'
import classNames from 'classnames'

interface MainViewProps {
  images: string[]
  viewportRefType: <ViewportElement extends HTMLElement>(
    instance: ViewportElement | null,
  ) => void
  mainClassNames?: string
  mainContainerClassNames?: string
  mainStyles?: React.CSSProperties
  imageObjectFit?: 'contain' | 'cover'
}

const MainView: React.FunctionComponent<MainViewProps> = ({
  viewportRefType,
  images,
  mainClassNames,
  mainContainerClassNames,
  mainStyles,
  imageObjectFit = 'cover',
}) => {
  return (
    <div
      className={classNames('relative px-4 lg:px-0', mainContainerClassNames)}
    >
      <div className="w-full h-full overflow-hidden" ref={viewportRefType}>
        <div className="flex h-full">
          {images.map((image, index) => (
            <div className="min-w-full h-full relative" key={index}>
              <div
                className={classNames(
                  'relative overflow-hidden w-full h-full',
                  mainClassNames,
                )}
                style={mainStyles}
              >
                <Image
                  alt=""
                  src={image}
                  priority
                  fill
                  sizes="100vw"
                  style={{
                    objectFit: imageObjectFit,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default MainView
